import './ToggleButtonGroupUiObject.scss';
import './Ribbon.scss';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { isBookingFeeOn, quotePrice, withBookingFee } from '../core/pricing';
import { OrderPageToggleButton } from '../themedComponents/OrderPageToggleButton';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { customerFacingPriceFormatter } from '../utils';
import { useLanguage } from '../../utils/GeneralUtils';

const ToggleButtonGroupUiObjectDynamicPrice = (props) => {
  const { uiObject, orderState, setOrderDetailValue } = props;
  const { t } = useTranslation();
  const language = useLanguage();

  const getDefaultValue = () => {
    return `${orderState.details[uiObject.data_type]}`;
  };

  const [value, setValue] = useState(getDefaultValue());
  const onValueChange = (e, val) => {
    if (val != null) {
      // for deselection
      setValue(val);
      setOrderDetailValue(uiObject.data_type, val);
    }
  };

  const getPrice = (value) => {
    const tempDetails = {
      ...orderState.details,
      [uiObject.data_type]: value,
    };

    return quotePrice({
      orderPage: orderState.orderPage,
      details: tempDetails,
      dateDetails: orderState.dateAndTimeDetails,
      account: orderState.account,
    }).total;
  };

  return (
    <Box className="toggle-button-ui-object" sx={{ marginBottom: 0 }}>
      <OrderPageTypography variant="h3" bold>
        {uiObject.label[language]}
      </OrderPageTypography>
      <Box className="toggle-button-container" sx={{ display: 'inline-block', marginBottom: '0!important' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left" />
              <TableCell align="center">
                <OrderPageTypography variant="h6">{t('order_page.table.price')}</OrderPageTypography>
              </TableCell>
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            {uiObject.options.map((option) => {
              return (
                <TableRow key={option.value} onClick={(e) => onValueChange(e, option.value)}>
                  <TableCell align="left" sx={{ paddingInlineStart: 0 }}>
                    <OrderPageToggleButton
                      sx={{ width: '140px', height: '60px' }}
                      className="toggle-button"
                      color="primary"
                      selected={option.value === value}
                      value={`${option.value}`}>
                      <Grid item>
                        <Grid item className="ribbon" hidden={!option.recommended}>
                          <OrderPageTypography variant="h6" color="primary">
                            {t('recommended')}
                          </OrderPageTypography>
                        </Grid>
                        <OrderPageTypography variant="h6">{option.label[language]}</OrderPageTypography>
                      </Grid>
                    </OrderPageToggleButton>
                  </TableCell>
                  <TableCell align="center">
                    <OrderPageTypography variant="h6">
                      {customerFacingPriceFormatter(
                        withBookingFee(getPrice(option.value), orderState.account),
                        orderState.account,
                      )}
                    </OrderPageTypography>
                  </TableCell>
                  <TableCell align="center">
                    <OrderPageTypography variant={'body1'} style={{ opacity: 0.7, textTransform: 'none' }}>
                      {`${customerFacingPriceFormatter(
                        isBookingFeeOn(orderState.account)
                          ? Math.round(
                              (withBookingFee(getPrice(option.value), orderState.account) /
                                orderState.details.persons) *
                                100,
                            ) / 100
                          : Math.round(getPrice(option.value) / orderState.details.persons),
                        orderState.account,
                      )} ${t('order_page.table.participant')}`}
                    </OrderPageTypography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default ToggleButtonGroupUiObjectDynamicPrice;
